import React from "react";

const ShieldCheckIcon = ({ width = 16, height = 16, stroke = "#059F00", ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.3334 8.66762C13.3334 12.001 11 13.6676 8.22669 14.6343C8.08146 14.6835 7.92371 14.6811 7.78002 14.6276C5.00002 13.6676 2.66669 12.001 2.66669 8.66762V4.00095C2.66669 3.82414 2.73693 3.65457 2.86195 3.52955C2.98697 3.40452 3.15654 3.33428 3.33335 3.33428C4.66669 3.33428 6.33335 2.53428 7.49335 1.52095C7.63459 1.40028 7.81426 1.33398 8.00002 1.33398C8.18578 1.33398 8.36545 1.40028 8.50669 1.52095C9.67335 2.54095 11.3334 3.33428 12.6667 3.33428C12.8435 3.33428 13.0131 3.40452 13.1381 3.52955C13.2631 3.65457 13.3334 3.82414 13.3334 4.00095V8.66762Z"
        stroke={stroke}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 7.99935L7.33333 9.33268L10 6.66602"
        stroke={stroke}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ShieldCheckIcon;
